import Alpine from 'alpinejs'
import { defineComponent, parsePath } from '~/scripts/utils/alpine'

type Component = ReturnType<typeof defineComponent>

export default function register() {
  // Auto-import components
  const components = import.meta.glob<() => Promise<Component>>('./**/*', {
    import: 'default',
  })

  for (const path in components) {
    const { name } = parsePath(path)
    Alpine.asyncData(name, components[path])
  }
}
